export const SwitchPageId = 'SwitchPage';

export enum SwitchPageAttributes {
  DEFAULT = 'defaultLink',
  LINKS = 'switchLinks',
}
